import { useEffect } from 'react';
import { type INPMetricWithAttribution, onINP } from 'web-vitals/attribution';

export const useWebVitals = () => {
  useEffect(() => {
    function sendToGoogleAnalytics({ name, value, id, attribution, entries }: INPMetricWithAttribution) {
      if (typeof gtag !== 'function') return;

      const { interactionTarget, interactionType, loadState } = attribution;
      const eventEntry = entries[0];

      const eventParams = {
        metric_inp_value: value,
        metric_id: id,
        metric_inp_event_target: interactionTarget,
        metric_inp_event_type: interactionType,
        metric_inp_load_state: loadState,
        metric_inp_start_time: eventEntry?.startTime,
        metric_inp_processing_start: eventEntry?.processingStart,
        metric_inp_processing_end: eventEntry?.processingEnd,
        metric_inp_duration: eventEntry?.duration,
        metric_inp_interaction_id: eventEntry?.interactionId,
      };

      // Send to Google Analytics
      gtag('event', name, eventParams);
    }
    onINP(sendToGoogleAnalytics);
  }, []);
};
